<template>
  <div>
    <breadcrumbs
      parentUrl="/"
      parentTitle="Start"
      currentTitle="Kontakta oss"
    />
    <div class="outer-wrapper">
      <div class="inner-wrapper">
        <af-h1>Kontakta oss</af-h1>

        <div class="section">
          <af-h2>Kontakta oss som arbetsgivare</af-h2>
          <p>
            Kontakta oss om du har några frågor eller funderingar om Jobskills.
            Se mer information
            <a href="https://arbetsformedlingen.se/kontakt/tekniska-problem"
              >här.</a
            >
          </p>
        </div>

        <div class="info-box-wrapper">
          <div class="info-box section">
            <af-h2 noMarginTop>Få tillgång till Jobskills söktjänst</af-h2>

            <p>
              För att få tillgång till Jobskills kandidatsök behöver du ha ett
              arbetsgivarkonto hos Arbetsförmedlingen. Med arbetsgivarkontot får
              du också tillgång till andra tjänster hos Arbetsförmedlingen,
              t.ex. möjligheten att lägga upp annonser på Platsbanken.
            </p>

            <external-link
              href="https://arbetsformedlingen.se/for-arbetsgivare/skapa-arbetsgivarkonto#/valjforetag"
              >Skapa ett arbetsgivarkonto</external-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AfH1 from '@/components/AfH1'
import AfH2 from '@/components/AfH2'
import AfH3 from '@/components/AfH3'
import ExternalLink from '@/components/ExternalLink'
import Icon from '@/components/Icon'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  components: {
    AfH1,
    AfH2,
    AfH3,
    ExternalLink,
    Icon,
    Breadcrumbs
  },
  name: 'Contact'
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';

.outer-wrapper {
  display: flex;
  max-width: var(--spacing-max-width-large);
  margin: var(--spacing-large) 15px 0;

  @media (--bp-nis-medium) {
    margin: 0 auto;
  }

  @media (--bp-nis-large) {
    width: var(--spacing-max-width-large);
  }
}

.inner-wrapper {
  align-items: start;
  margin: 0 var(--spacing-half);

  @media (--bp-nis-medium) {
    padding: var(--spacing-large);
    margin-top: 0;
  }

  @media (--bp-nis-large) {
    padding: var(--spacing-large) 0;
    margin: 0;
  }
}

.section {
  max-width: var(--spacing-max-width-medium);
}

.info-box-wrapper {
  margin-bottom: var(--spacing-large);
  margin-top: var(--spacing-large);
}

.info-box {
  border-left: 7px solid var(--color-venice-blue);
  background-color: var(--color-alabaster);
  padding: var(--spacing);
  margin: var(--spacing-half) 0;
}

.info-box:last-of-type {
  margin-top: var(--spacing);
}

.text-link {
  & i {
    margin-right: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue